<frog-landing-toolbar></frog-landing-toolbar>

@if (user$ | async) {}

@if (hosted) {
    <div class="flex column root">
        <section class="jumbotron flex align-center justify-center">
            <div class="flex flex-60 column align-center justify-stretch hosted-info">
                <h3>Super User</h3>
                <p>
                    Login to create a Super User, this user will have complete control of the
                    instance
                </p>
                <div>
                    <button mat-flat-button (click)="login(false)">Login</button>
                </div>
            </div>
        </section>
        <section class="flex row align-center justify-center">
            <div class="flex flex-60 column align-center justify-stretch hosted-info">
                <h3>Backoffice</h3>
                <p>
                    Super Users also have access to
                    <a rel="noreferrer" target="_blank" href="https://{{ hostname }}.backoffice"
                        >https://{{ hostname }}.backoffice</a
                    >
                </p>
                <p>
                    Backoffice will give you a birds eye view of all workspaces, assets, and users
                    in the instance.
                </p>
            </div>
        </section>
    </div>
} @else {
    <div class="flex column root">
        <section class="jumbotron flex align-center justify-center">
            <div class="flex header">
                <div class="title flex column align-center justify-center">
                    <h1>FrogEye</h1>
                    <h3>A Simple Platform for Asset Discovery</h3>
                    <div>
                        <button mat-flat-button color="primary" (click)="login(true)">
                            Get Started
                        </button>
                    </div>
                </div>
                <div class="abstract-view">
                    <img src="assets/images/abstractview.png" />
                </div>
            </div>
        </section>
        <section class="flex row align-center justify-center">
            <div class="flex justify-center section-content">
                <div class="flex column align-center justify-stretch tenet">
                    <mat-icon fontSet="material-icons-outlined">visibility</mat-icon>
                    <h1>Visible</h1>
                    <p>
                        FrogEye was built with the idea that the content was by and large the most
                        important thing. It was designed to be highly visual and pleasant to use.
                        There's no crufty UI for managing deep hierarchies or endless metadata. Just
                        content. Front and center.
                    </p>
                </div>
                <div class="flex column align-center justify-stretch tenet">
                    <mat-icon fontSet="material-icons-outlined">touch_app</mat-icon>
                    <h1>Simple</h1>
                    <p>
                        FrogEye is simple to use and easy to add media files to. Users can upload
                        and view media instantly and the entire team benefits.
                    </p>
                </div>
                <div class="flex column align-center justify-stretch tenet">
                    <mat-icon fontSet="material-icons-outlined">search</mat-icon>
                    <h1>Discoverable</h1>
                    <p>
                        One of the biggest problems in creative studios is that their media is
                        usually hosted on a network or cloud drive somewhere and, if you're lucky,
                        organized in folders. Searching by filename or digging through endless
                        folders is a nightmare. Being able to browse all media in one place and see
                        everything at once makes discovery a snap.
                    </p>
                </div>
            </div>
        </section>
        <section class="flex align-center justify-center info">
            <div class="flex justify-center section-content">
                <a id="features"></a>
                <div class="flex column align-start justify-stretch tenet">
                    <mat-icon fontSet="material-icons-outlined">monitor_heart</mat-icon>
                    <h1>A Visual Pulse for Your Team</h1>
                    <h2>Everything you need to share, find, and discover your content</h2>
                </div>
                <div class="asset-support">
                    <h2>Asset Support</h2>
                    <p>
                        For most content creators, it comes down to a few different types on
                        content, Image, Video, and 3D. FrogEye supports each of these and does it
                        well.
                    </p>
                    <p>
                        Image: We support all common image formats including JPEG, PNG, PSD, PSB,
                        TIFF, and TGA. The viewer was written for speed when viewing full
                        resolution, large images with minimal UI so you can focus on the content.
                    </p>
                    <p>
                        Video support is also well done with a wide range of video formats accepted
                        and converted for web viewing.
                    </p>
                    <p>
                        3D support via the
                        <a href="https://marmoset.co/toolbag/viewer/" rel="external" target="_blank"
                            >Marmoset viewer</a
                        >. This is an incredible viewer supporting high resolution models and
                        animation. It uses PBR shaders and can show the different texture maps for
                        your models. You can find out more at marmoset.co
                    </p>

                    <h2>Content Flow</h2>
                    <p>
                        FrogEye is built around the concept of Streams. Essentially Streams provide
                        a boundary for categories of content. There are no folders or other
                        hierarchies to get in the way, just a steady stream of content.
                    </p>

                    <h2>Search &amp; Filter</h2>
                    <p>
                        As the amount of content grows, using any sort of hierarchy becomes
                        impractical, searching and filtering is needed in order to navigate all of
                        your content. FrogEye has a rich search and filter system:
                    </p>
                    <ul>
                        <li>Full Text Search</li>
                        <li>Tag Filtering</li>
                        <li>Boolean Operators (AND & OR) to expand or reduce results</li>
                        <li>Filter by Date Range</li>
                        <li>Filter by User</li>
                    </ul>
                </div>
            </div>
        </section>
        <section class="flex align-center justify-center jumbotron">
            <div class="flex column justify-center about">
                <div class="flex column align-center justify-center title">
                    <h2>Developed By</h2>
                    <h3>Brett</h3>
                    <p>
                        As a seasoned Technical Artist, I have been working with artists my entire
                        career and was an aspiring artist for most of my life. My unique position
                        gave me great insight into how to make this tool as easy as possible for
                        real world artists as well as all of the folks involved in making a game.
                        Thanks for checking it out
                    </p>
                </div>
                <div class="abstract-view">
                    <img src="assets/images/about.jpg" />
                </div>
            </div>
        </section>
    </div>

    <frog-try-block></frog-try-block>
}

<frog-footer></frog-footer>
